/**
 * FashSnapResult Component
 * FashSnap grid sonuç ekranı - polaroid gallery
 */

import React, { useState } from 'react';
import './FashSnapResult.css';

const IMAGE_LABELS = ['Fit Check', 'Günlük Hayat', 'Detay Görünüm', 'Sosyal'];

export interface FashSnapResultProps {
    generatedImages: string[];
    onResetUser: () => void;
    labels?: string[];
    resetLabel?: string;
}

export const FashSnapResult: React.FC<FashSnapResultProps> = ({
    generatedImages,
    onResetUser,
    labels = IMAGE_LABELS,
    resetLabel = 'Yeni Avatar ile Dene'
}) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);

    const handleImageClick = (index: number) => {
        setSelectedImageIndex(index);
    };

    const handleCloseGallery = () => {
        setSelectedImageIndex(null);
    };

    const handlePrevImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (selectedImageIndex !== null) {
            setSelectedImageIndex((selectedImageIndex - 1 + generatedImages.length) % generatedImages.length);
        }
    };

    const handleNextImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (selectedImageIndex !== null) {
            setSelectedImageIndex((selectedImageIndex + 1) % generatedImages.length);
        }
    };

    return (
        <>
            <div className="fashsnap-content">
                <section className="results-section">
                    <div className="results-grid">
                        {generatedImages.map((imgUrl, index) => {
                            const rotation = ((index * 7) % 10) - 5;
                            return (
                                <div
                                    key={index}
                                    className="polaroid-card"
                                    onClick={() => handleImageClick(index)}
                                    style={{ '--polaroid-rotation': `${rotation}deg` } as React.CSSProperties}
                                >
                                    <img
                                        src={imgUrl}
                                        alt={`Stil ${index + 1}`}
                                        className="polaroid-card__image"
                                    />
                                    <p className="polaroid-card__caption">
                                        {labels[index] || `Stil ${index + 1}`}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                </section>
            </div>

            {selectedImageIndex !== null && (
                <div className="gallery-modal" onClick={handleCloseGallery}>
                    <div className="gallery-close-btn-container">
                        <button className="gallery-close" onClick={handleCloseGallery}>×</button>
                    </div>
                    
                    <button className="gallery-nav prev" onClick={handlePrevImage}>❮</button>
                    
                    <div className="gallery-main-content" onClick={(e) => e.stopPropagation()}>
                        <div className="gallery-image-container">
                            <div className="gallery-polaroid-frame">
                                <img src={generatedImages[selectedImageIndex]} className="gallery-image" alt="Full view" />
                                <p className="gallery-caption">
                                    {labels[selectedImageIndex] || `Stil ${selectedImageIndex + 1}`}
                                </p>
                            </div>
                        </div>
                        
                        <div className="gallery-thumbnails">
                            {generatedImages.map((imgUrl, idx) => (
                                <div 
                                    key={idx}
                                    className={`gallery-thumb-item ${selectedImageIndex === idx ? 'active' : ''}`}
                                    onClick={() => setSelectedImageIndex(idx)}
                                >
                                    <img src={imgUrl} alt={`Küçük resim ${idx + 1}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                    
                    <button className="gallery-nav next" onClick={handleNextImage}>❯</button>
                </div>
            )}

            <div className="fashsnap-bottom-actions">
                <button
                    className="fashsnap-cta-secondary"
                    onClick={onResetUser}
                >
                    {resetLabel}
                </button>
            </div>
        </>
    );
};

export default FashSnapResult;
